export enum DateUnit {
  Year = 0,
  Month,
  Day,
  Hour,
  Minute,
  Second
}

export const DATE_DISPLAY_FORMAT = 'MMM d, yyyy, h:mma'

export const DATE_DISPLAY_SLASH_FORMAT = 'dd/MM/yyyy'

export const DATE_DISPLAY_FORMAT_WITHOUT_TIME = 'dd-MMM-yyyy'

export const DATE_DISPLAY_FORMAT_MONTH_DAY_YEAR = 'MMM d, yyyy'

export const MILLISECONDS_IN_DAY = 86400000
